// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2385":"4d67e740","4513":"c540e03f","5143":"c540e03f","7366":"b36d20cf","9617":"a3579176","9925":"20561f50"}[chunkId] + ".chunk.css";
};